import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PickService {
  /**
   * Creates a new object with only the specified properties from the original object
   * @param object The object to pick properties from
   * @param paths The property paths to pick from the object
   * @returns A new object with only the specified properties
   */
  static pick<T extends object>(object: T, paths: string | string[]): Partial<T> {
    // Convert single string path to array for consistent handling
    const keys = Array.isArray(paths) ? paths : [paths];

    // Create a new object with only the specified properties
    return keys.reduce((acc, key) => {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        acc[key as keyof T] = object[key as keyof T];
      }
      return acc;
    }, {} as Partial<T>);
  }
}
